import { pascalCase as pascalCase$1 } from "pascal-case";
const pascalCase = (...input) => {
  return pascalCase$1(input.filter(Boolean).join(" "));
};
export {
  pascalCase
};
//# sourceMappingURL=pascalCase.js.map
